export const COIN_IMAGES = {
  emami: "/coin-emami86.jpg",
  emami_old: "/coin-emami86.jpg",
  bahar: "/coin-bahar.jpg",
  nim86: "/coin-spring.jpg",
  rob86: "/coin-spring.jpg",
  gerami: "/coin-spring.jpg",
  nim_old: "/coin-spring.jpg",
  rob_old: "/coin-spring.jpg",
};
